<template>
	<v-dialog v-model="dialog" max-width="600">
		<v-card v-if="loading" color="primary" dark>
			<v-card-text >
				{{$t('pages.shareDialog.standBy')}}
				<v-progress-linear indeterminate color="white" class="mb-0" />
			</v-card-text>
		</v-card>
		<v-card v-else>
			<v-toolbar>
				<v-toolbar-title class="pr-4">{{ $t("pages.shareDialog.shareGame") }}</v-toolbar-title>
			</v-toolbar>
			<v-card-text class="mt-3">
				<v-row>
					<v-col class="pb-0">
						<v-switch

							:label="form.share ? $t('generics.active'):$t('generics.draft')" @change="activeActive" v-model="form.share"></v-switch>
					</v-col>
				</v-row>

			</v-card-text>
      <v-card-text>

        <!--				        Dont remove. will uncommitted vary soon-->
        <v-row  class="mt-0" v-if="game.share">
          <v-col class="pt-0">
            <v-switch :label="$t('generics.showIn')+' MyLab (' + $t('generics.private') + ')'" @change="updateGallery" v-model="form.gallery"></v-switch>
          </v-col>
          <v-col class="pt-0">
            <v-switch :label="$t('generics.showIn')+' OpenLab (' + $t('generics.public') + ')'" @change="updatePublicGallery" v-model="form.public_gallery"></v-switch>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text class="mt-3" v-if="game.share">
        <share-link v-if="game.share" :game="game"/>
        <share-link :game="game" :isIframe="true"/>
			</v-card-text>

			<v-card-actions>
				<v-spacer/>
				<v-btn color="blue darken-1" text @click="dialog = false">
					{{ $t("generics.close") }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>

import ShareLink from "src/view/share/ShareLink";
import { types } from "../../store/modules/Game.module";

export default {
	name: "ShareDialog",
	components: { ShareLink },
	props: {
		value: { type: Boolean },
		game: { type: Object, required: true },
	},
	data() {
		return {
			loading: false,
			form:{
				share:false,
				gallery:false,
        public_gallery:false
			}
		};
	},
	computed: {
		dialog: {
			get () {
				return this.value;
			},
			set (val) {
				this.$emit("input", val);
			},
		},
	},
	methods: {
		activeActive(){
			this.$store.dispatch(types.SAVE,Object.assign(this.game,{
				share:this.form.share
			}));
		},
		updatePublic(){
			const data = Object.assign(this.game,{
				gallery:this.form.gallery,
				public_gallery:this.form.public_gallery
			});
			this.$store.dispatch(types.SAVE,data);
		},
		updateGallery(){
			const data = Object.assign(this.game,{
				gallery: this.form.gallery,
			});
			this.$store.dispatch(types.SAVE,data);
		},
		updatePublicGallery(){
			const data = Object.assign(this.game,{
				public_gallery: this.form.public_gallery,
			});
			this.$store.dispatch(types.SAVE,data);
		},
	},
	watch : {
		["game.id"]:{
			immediate:true,
			handler(){
        console.log(this.game.public_gallery);
				this.form.share = this.game.share;
				this.form.gallery = this.game.gallery;
				this.form.public_gallery = this.game.public_gallery;
			}
		}




	}
};
</script>
